export default __webpack_public_path__ + "static/media/11.bc41182f.jpg";